import { createSlice } from '@reduxjs/toolkit';

const databaseSlice = createSlice({
    name: 'database',
    initialState: null,
    reducers: {
        setDatabaseInstance: (state, action) => {
            return action.payload;
        },
    },
});

export const { setDatabaseInstance } = databaseSlice.actions;
export default databaseSlice.reducer;